import React from "react";
// import hero1 from "../assets/BuildingsOman.jpg";
import hero1 from "../assets/TIG Website Images/Home/Slide deck/Towers International Group.png";
import hero2 from "../assets/TIG Website Images/Our Businesses/Northstar/d.png";
import hero3 from "../assets/TIG Website Images/Our Businesses/Elevate/elevate.png";
import hero4 from "../assets/TIG Website Images/Home/Slide deck/newe.png";
import hero5 from "../assets/TIG Website Images/Home/Slide deck/Modern Buildings Construction.png";
import hero6 from "../assets/TIG Website Images/Our Businesses/Vodafone Distribution/VodafoneDepartment.png";
import hero7 from "../assets/TIG Website Images/Our Businesses/HR Solutions/HR.png";
import hero8 from "../assets/TIG Website Images/Home/Slide deck/Towers Training.png";
import hero9 from "../assets/TIG Website Images/Our Businesses/CXDA/CXDAOman.png";
const slides = [
  {
    image: hero1,
    subtitle: "CREATIVE & INNOVATIVE",
    title: "Towers International Group of Companies",
  },
  {
    image: hero2,
    subtitle: "INTEGRITY & GROWTH",
    title: "NorthStar Financial Consultancy",
  },
  {
    image: hero3,
    subtitle: "EXPERIENCE & EXPERTISE",
    title: "Elevate Management Services LLC",
  },
  {
    image: hero4,
    subtitle: "GLOBAL CONNECTIONS",
    title: "New Elite International LLC",
  },
  {
    image: hero5,
    subtitle: "ADVANCING SOLUTIONS",
    title: "Modern Buildings Constructions LLC",
  },
  {
    image: hero6,
    subtitle: "YOUR PARTNER IN SUCCESS",
    title: "Vodafone Distribution",
  },
  {
    image: hero7,
    subtitle: "INNOVATING HUMAN CAPITAL",
    title: "HR Solutions",
  },
  {
    image: hero8,
    subtitle: "BUILDING FUTURE LEADERS",
    title: "Towers Training",
  },
  {
    image: hero9,
    subtitle: "DATA DRIVEN IMPACT",
    title: "CXDA",
  },
];

const HeroCarousel = () => {
  return (
    <div className="container-fluid p-0">
      <div
        id="header-carousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="4000"
        data-bs-pause="false"
        data-bs-wrap="true"
      >
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              key={index}
              style={{ height: "85vh", position: "relative" }}
            >
              <img
                className="w-100 h-100"
                src={slide.image}
                alt={`Slide ${index + 1}`}
                style={{ objectFit: "cover" }}
              />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
                <div className="col-lg-10 zoom-in-text">
                  <p className="text-uppercase text-light m-0">
                    {slide.subtitle}
                  </p>
                  <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                    {slide.title}
                  </h1>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
  );
};

export default HeroCarousel;
